import React, { PureComponent } from 'react';

class LevelUpAnimation extends PureComponent {
    render() {
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                <div style={styles.ring} />
                <div style={styles.ring2} />
                <div style={styles.textContainer}>
                    <div style={styles.text}>LEVEL UP</div>
                </div>
                <div style={styles.rays} />
            </div>
        );
    }
}

const keyframes = `
@keyframes level-ring-expand {
    0% { transform: scale(0); opacity: 0.8; }
    100% { transform: scale(3); opacity: 0; }
}
@keyframes level-text-appear {
    0% { transform: scale(0.3) translateY(20px); opacity: 0; }
    40% { transform: scale(1.3) translateY(-5px); opacity: 1; }
    60% { transform: scale(0.95) translateY(2px); opacity: 1; }
    100% { transform: scale(1) translateY(0); opacity: 1; }
}
@keyframes level-rays {
    0% { transform: rotate(0deg); opacity: 0.3; }
    100% { transform: rotate(180deg); opacity: 0; }
}
`;

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    ring: {
        position: 'absolute',
        width: 100,
        height: 100,
        borderRadius: '50%',
        border: '3px solid #FFD700',
        animation: 'level-ring-expand 1.5s ease-out forwards',
    },
    ring2: {
        position: 'absolute',
        width: 100,
        height: 100,
        borderRadius: '50%',
        border: '2px solid #FFA500',
        animation: 'level-ring-expand 1.5s ease-out 0.2s forwards',
    },
    textContainer: {
        position: 'relative',
        animation: 'level-text-appear 0.8s ease-out 0.1s both',
    },
    text: {
        fontSize: 42,
        fontWeight: 900,
        color: '#FFD700',
        textShadow: '0 0 20px rgba(255, 215, 0, 0.6), 0 0 40px rgba(255, 165, 0, 0.3)',
        letterSpacing: 6,
        fontFamily: 'inherit',
    },
    rays: {
        position: 'absolute',
        width: 300,
        height: 300,
        background: 'conic-gradient(from 0deg, transparent, rgba(255, 215, 0, 0.1), transparent, rgba(255, 215, 0, 0.1), transparent, rgba(255, 215, 0, 0.1), transparent, rgba(255, 215, 0, 0.1), transparent)',
        animation: 'level-rays 3s linear forwards',
    },
};

export default LevelUpAnimation;
